/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetExchangesResponseStatus = typeof GetExchangesResponseStatus[keyof typeof GetExchangesResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExchangesResponseStatus = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  USER_INSUFFICIENT_FUND: 'USER_INSUFFICIENT_FUND',
  TRADER_INSUFFICIENT_FUNDS: 'TRADER_INSUFFICIENT_FUNDS',
  PENDING_HEDGE: 'PENDING_HEDGE',
  USER_CANCEL: 'USER_CANCEL',
  RFQ_FAILED: 'RFQ_FAILED',
  REQUESTED: 'REQUESTED',
  VOID: 'VOID',
} as const;
